<template>
    <div>
        <modal :show="show" :close="() => {}">
            <template v-slot:header>
                <h1 class="header">{{ $t("at_home.finish.header") }}</h1>
            </template>

            <template v-slot:body>
                <div class="body-text">
                    <p class="font-weight-bold">
                        {{ $t("at_home.finish.body-1") }}
                    </p>

                    <p>
                        {{ $t("at_home.finish.body-2", { minPurchaseAmount: formattedMinPurchaseAmount }) }}
                    </p>

                    <p class="font-weight-bold">
                        {{ $t("at_home.finish.body-3") }}
                    </p>

                    <div v-if="address">
                        <div v-show="address.line1">{{ address.line1 }}</div>
                        <div v-show="address.line2">{{ address.line2 }}</div>
                        <div v-show="cityStateZip">{{ cityStateZip }}</div>
                    </div>
                    <div v-show="phoneNumber">{{ phoneNumber }}, Option 2</div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import Modal from "./Modal.vue"
    import { locationService, workflowService } from "@/service"
    import { mapState } from "vuex"
    import Providers from "@/model/provider/Providers"
    import FinishFlowAction from "@/action/actions/FinishFlowAction"
    import FinishType from "@/model/flow/FinishType"
    import { sessionState } from "@/state"
    import { formatCurrency } from "@/util/currency"

    export default {
        name: "AtHomeFinishModal",

        components: {
            Modal,
        },

        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                location: null,
                finished: false,
            }
        },

        computed: {
            ...mapState("provider", {
                minPurchaseAmount: state => {
                    return state.providers.find(provider => provider.providerKey === sessionState.providerKey)
                        ?.minPurchaseAmountCents
                },
            }),

            ...mapState("session", {
                preauthExpireDays: state => {
                    return Providers[state.data.dynamicProviderKey.providerKey]?.preauthExpireDays
                },
            }),

            address() {
                return this.location?.address
            },

            cityStateZip() {
                let builder = ""

                if (this.address?.city) {
                    builder += this.address.city
                }

                if (this.address?.state) {
                    builder += ", " + this.address.state
                }

                if (this.address?.zipCode) {
                    builder += " " + this.address.zipCode
                }

                return builder
            },

            formattedMinPurchaseAmount() {
                return formatCurrency(this.minPurchaseAmount, "cents", true)
            },

            phoneNumber() {
                return this.location?.phoneNumber
            },
        },

        async created() {
            this.location = await locationService.getCurrentLocation()
        },

        methods: {},

        watch: {
            show(value) {
                if (value && !this.finished) {
                    this.finished = true
                    workflowService.invoke(new FinishFlowAction(FinishType.COMPLETED, true))
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .overflow-hidden {
        overflow: hidden;
    }

    .header {
        padding-top: to_rem(24px);
        padding-bottom: to_rem(16px);
        font-style: normal;
        font-weight: 600;
        font-size: to_rem(26px);
        line-height: to_rem(32px);
        letter-spacing: -0.5px;
        color: $primary-color;
    }

    .body-text {
        font-weight: 400;
        font-size: to_rem(18px);
        color: $grey-darken-2;
        line-height: to_rem(28px);
    }
</style>
